
var pf_config = require('../pf_config.json');

var niceName = {
  teams: "Teams",
  "pro": "Pro",
  "open": "Open Source",
  "trial": "Trial"
}

const generateLockedTooltipText = (feature_name) => {
  var text = "This feature is only available for ";

  const feature = pf_config.features[feature_name];

  var list = [];
  for(var i in feature.availability){
    if(feature.availability[i]){
      list.push(i);
    }
  }

  for(var i in list){
    text += niceName[list[i]];
    if(i < list.length - 1) text += ', ';
    if(i == list.length - 2) text += ' and ';
  }
  text += " accounts.";

  return text;
}

export default generateLockedTooltipText;


// WEBPACK FOOTER //
// ./src/pattern_utilities/generateLockedTooltipText.js